import { useQuery } from '../useQuery';
import { getTaskAssignments } from '@dispatch/shared/services';

export const useGetTaskAssignments = (taskId: string) => {
  const { data, status, refetch } = useQuery(['task-assignments', taskId], () =>
    getTaskAssignments(taskId)
  );

  return {
    taskAssignments: data || [],
    taskAssignmentsStatus: status,
    fetchTaskAssignments: refetch,
  };
};
